const locationProviderConfig = ($locationProvider) => {
  'ngInject';

  $locationProvider.html5Mode(true);
};

export default locationProviderConfig;
